import React from 'react';
import { GraduationCapIcon, CrosshairIcon } from 'lucide-react';
import { SlideFrame, SlideTitle } from '../deck/SlideFrame';
export function TwoRoutesSlide() {
  return <SlideFrame marker="The fork" isLast data-id="element-158" data-mp="1rfdhjw66dy4z">
      <SlideTitle sub="A gap can be closed two ways, and they cost very different money. Most brands need both — but never in the same proportion, and never in the same segment." data-id="element-159" data-mp="1rgf4axwk092j">
        Two routes out of the gap
      </SlideTitle>

      <div className="mt-[3.5vh] grid min-h-0 flex-1 grid-cols-2 gap-[4%]" data-id="element-160" data-mp="20i4ww7269e1w">
        <article className="flex min-h-0 flex-col rounded-2xl bg-gapAccent px-[6%] py-[3vh] text-white" data-id="element-161" data-mp="1wdouwgvoiqry">
          <span className="flex h-[clamp(32px,3.6vw,58px)] w-[clamp(32px,3.6vw,58px)] items-center justify-center rounded-2xl bg-white/15" data-id="element-162" data-mp="2adpuzu44du6d">
            <GraduationCapIcon aria-hidden="true" className="h-[clamp(17px,2vw,32px)] w-[clamp(17px,2vw,32px)] text-white" data-id="element-163" data-mp="g06x2j66g9kj" />
          </span>
          <h3 className="mt-[1.6vh] font-display text-[clamp(21px,3vw,50px)] leading-[1.05]" data-id="element-164" data-mp="b3gla81eo04x">
            Route A — Educate
          </h3>
          <p className="mt-[1.2vh] text-[clamp(11px,1.28vw,21px)] leading-[1.45] text-white/80" data-id="element-165" data-mp="1b0gyyk10k7yg">
            The HCPs are the right ones. Their beliefs are behind the evidence.
          </p>
          <ul className="mt-auto flex flex-col gap-[1.1vh] border-t border-white/25 pt-[2vh]" data-id="element-166" data-mp="1ju3se3hr0z4h">
            <li className="text-[clamp(11px,1.22vw,20px)] leading-[1.35] text-white" data-id="element-167" data-mp="1osx35o5nic0y">
              “We are better than you think.”
            </li>
            <li className="text-[clamp(11px,1.22vw,20px)] leading-[1.35] text-white" data-id="element-168" data-mp="1tq6uxagiizry">
              “The criteria you rank first are the wrong ones.”
            </li>
          </ul>
        </article>

        <article className="flex min-h-0 flex-col rounded-2xl border border-ink-line bg-paper-card px-[6%] py-[3vh]" data-id="element-169" data-mp="22rwlke2kluoo">
          <span className="flex h-[clamp(32px,3.6vw,58px)] w-[clamp(32px,3.6vw,58px)] items-center justify-center rounded-2xl bg-paper-tint" data-id="element-170" data-mp="4ewh06dgt6w3">
            <CrosshairIcon aria-hidden="true" className="h-[clamp(17px,2vw,32px)] w-[clamp(17px,2vw,32px)] text-gapAccent" data-id="element-171" data-mp="1boj782jysydl" />
          </span>
          <h3 className="mt-[1.6vh] font-display text-[clamp(21px,3vw,50px)] leading-[1.05] text-ink" data-id="element-172" data-mp="1kpr5wlqe8187">
            Route B — Target
          </h3>
          <p className="mt-[1.2vh] text-[clamp(11px,1.28vw,21px)] leading-[1.45] text-ink-soft" data-id="element-173" data-mp="1gmuh2da9f8vt">
            The beliefs are fair. We are simply in front of the wrong
            prescribers.
          </p>
          <ul className="mt-auto flex flex-col gap-[1.1vh] border-t border-ink-line pt-[2vh]" data-id="element-174" data-mp="1poty35l9ycyr">
            <li className="text-[clamp(11px,1.22vw,20px)] leading-[1.35] text-ink" data-id="element-175" data-mp="24dgqa7w02z7e">
              “Find the HCPs whose criteria already fit.”
            </li>
            <li className="text-[clamp(11px,1.22vw,20px)] leading-[1.35] text-ink" data-id="element-176" data-mp="2de53j0dkkvj8">
              “Stop paying for the unwinnable.”
            </li>
          </ul>
        </article>
      </div>
    </SlideFrame>;
}